let siteNavigation = document.getElementById('site-navigation');
let menuItems = document.querySelectorAll('.menu-item')

// Toggle Main Menu + Change Aria-Status
let menuButton = document.getElementById('main-menu-button');

if(menuButton) {
    menuButton.addEventListener('click', () => {
        toggleMobileMenu(siteNavigation)
    })
}

if(menuItems.length > 0) {
    for (const menuItem of menuItems) {
        menuItem.addEventListener('click', function() {
            if(siteNavigation.classList.contains('hidden')) {
                console.log("ywllow");
            } else {
                siteNavigation.classList.toggle('hidden')
                siteNavigation.ariaExpanded = "false"
            }
        });
    }
}

function toggleMobileMenu(item) {
    if (item.ariaExpanded != "true") {
        item.classList.remove('hidden');
        item.ariaExpanded = "true"
    } else {
        item.classList.add('hidden');
        item.ariaExpanded = "false"
        
    }
}

// Move main-container down when menu opens

function moveMainElement(element) {

    let mainContainer = document.getElementsByTagName('main')[0];
    if(mainContainer.offsetWidth >= 1024) {
        mainContainer.style.transform = `translateY(${element}px)`;
    }
}

// Toggle Submenu + Change Aria-Status + Set .active class on button

let activeSubmenu;
let activeButton

function toggleSubMenu(menu, button) {

    if(activeSubmenu == menu) {
        activeSubmenu.classList.add('hidden');
        activeButton.classList.remove('active');
        activeSubmenu.ariaExpanded = false;
        activeSubmenu = null;
        activeButton = null;
        moveMainElement(0);
        return
    } 
    else if(activeSubmenu != null && activeSubmenu != menu) 
    {
        activeSubmenu.classList.add('hidden');
        activeButton.classList.remove('active');
        activeSubmenu.ariaExpanded = false;
    }
    
    menu.classList.remove('hidden');
    menu.ariaExpanded = true;
    button.classList.add('active')
    activeSubmenu = menu;
    activeButton = button

    moveMainElement(activeSubmenu.offsetHeight);
}


// Toggle Sub-Menu 
let subMenuButtons = siteNavigation.querySelectorAll('button');

if(subMenuButtons) {
    subMenuButtons.forEach((subMenuButton) => {
        subMenuButton.addEventListener('click', () => {
            toggleSubMenu(subMenuButton.nextElementSibling, event.target)
            changeColor(subMenuButton.nextElementSibling)
        })
    })
}


// Toggle Kontakt Feld

let kontaktButtons = document.querySelectorAll('.kontakt-button')
let kontaktFeld = document.getElementById('kontakt')

function toggleKontaktFeld() {
    if(siteNavigation.ariaExpanded == "true") {
        toggleMobileMenu(siteNavigation)
        setTimeout(() => {
            kontaktFeld.classList.toggle('hidden')
        }, 180);
    } else {
        kontaktFeld.classList.toggle('hidden')
    }
}

if(kontaktButtons.length > 0) {
    for (const button of kontaktButtons) {
        button.addEventListener('click', toggleKontaktFeld)
    }
}

// FAQ

let faqs = document.querySelectorAll('.faq')

function showMeDaMoney(e) {
    if(e.target.getAttribute('aria-expanded') == "false" ) {
        let answer = e.target.parentElement.nextElementSibling;
        let bigPlus = e.target.querySelectorAll('i').item(0)
        e.target.ariaExpanded = "true"
        answer.classList.toggle('hidden')
        bigPlus.classList.toggle('tilted')
    } else {
        let answer = e.target.parentElement.nextElementSibling;
        e.target.ariaExpanded = "false"
        answer.classList.toggle('hidden')
    }
}

if(faqs.length > 0) {
    for (const faq of faqs) {
        faq.addEventListener('click', showMeDaMoney)
    }
}